// extracted by mini-css-extract-plugin
module.exports = {"top":"self-test_top__plOjw","topText":"self-test_topText__2bBmD","container":"self-test_container__a3RgA","underConstruction":"self-test_underConstruction__3Q0vS"};